import React from 'react';
import PermissionMatrix from './PermissionMatrix';

const Operations = (props) => (
  <PermissionMatrix {...props} areaLabel="Operações" hierarchy={['Diretor', 'Gerente', 'Analista', 'Estagiário']} />
);

export default Operations;
